import Vue from 'vue'
import Router from 'vue-router'
import Brand from '@/components/Brand' //首页
import BrandDescription from '@/components/BrandDescription' //集团简介
import AboutTetra from '@/components/AboutTetra' //德彩
import SmartBones from '@/components/SmartBones' //洁齿骨
import AboutSmartBone from '@/components/AboutSmartBone' //品牌介绍洁齿骨
import SmartBonesClassic from '@/components/SmartBonesClassic' //洁牙经典产品
import SmartBonesFunction from '@/components/SmartBonesFunction' //洁牙功能性产品
import SmartBonesInnovation from '@/components/SmartBonesInnovation' //洁牙创新性产品
import AboutFurminator from '@/components/AboutFurminator' //富美内特
import AboutNatureMiracle from '@/components/AboutNatureMiracle' //天然奇迹

import BrandNews from '@/components/BrandNews' //动态
import BrandNewsDetail from '@/components/BrandNewsDetail' //动态详情
import TetraNews from '@/components/TetraNews' //德彩动态详情
import SmartbonesNews from '@/components/SmartbonesNews' //洁齿骨动态详情
import FURminatorNews from '@/components/FURminatorNews' //富美内特动态详情
import CompetitionNews from '@/components/CompetitionNews' //德彩比赛动态详情
import Instructions from '@/components/Instructions' //instructions说明书详情



import Distributor from '@/components/Distributor' //经销商
import AllProduct from '@/components/AllProduct' //所有产品
import Tetraproduct from '@/components/Tetraproduct' //德彩产品

import contactUs from '@/components/contactUs' //联系我们

import Tropicalfish from '@/components/Tropicalfish' //热带鱼鱼粮




Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'Brand',
            component: Brand
        },
        {
            path: '/BrandDescription',
            name: 'BrandDescription',
            component: BrandDescription
        },
        {
            path: '/AboutTetra',
            name: 'AboutTetra',
            component: AboutTetra
        },
        {
            path: '/AboutSmartBone',
            name: 'AboutSmartBone',
            redirect: '/AboutSmartBone/About',
            component: SmartBones,
            children: [{
                    path: '/AboutSmartBone/About',
                    name: 'AboutSmartBoneAbout',
                    component: AboutSmartBone
                },
                {
                    path: '/AboutSmartBone/SmartBonesClassic',
                    component: SmartBonesClassic,
                    name: 'SmartBonesClassic'
                },
                {
                    path: '/AboutSmartBone/SmartBonesFunction',
                    name: 'SmartBonesFunction',
                    component: SmartBonesFunction
                },
                {
                    path: '/AboutSmartBone/SmartBonesInnovation',
                    name: 'SmartBonesInnovation',
                    component: SmartBonesInnovation
                },
            ]
        },
        {
            path: '/AboutFurminator',
            name: 'AboutFurminator',
            component: AboutFurminator
        },
        {
            path: '/AboutNatureMiracle',
            name: 'AboutNatureMiracle',
            component: AboutNatureMiracle
        },
        {
            path: '/BrandNews',
            name: 'BrandNews',
            component: BrandNews
        },
        {
            path: '/BrandNewsDetail',
            name: 'BrandNewsDetail',
            component: BrandNewsDetail
        },
        {
            //德彩新闻
            path: '/TetraNews',
            name: 'TetraNews',
            component: TetraNews
        },
        {
            //洁齿骨新闻
            path: '/SmartbonesNews',
            name: 'SmartbonesNews',
            component: SmartbonesNews
        },
        {
            //富美内特新闻
            path: '/FURminatorNews',
            name: 'FURminatorNews',
            component: FURminatorNews
        },

        {
            //比赛新闻
            path: '/CompetitionNews',
            name: 'CompetitionNews',
            component: CompetitionNews
        },

        {
            //德彩说明书
            path: '/Instructions',
            name: 'Instructions',
            component: Instructions
        },
       
        {
            //经销商
            path: '/Distributor',
            name: 'Distributor',
            component: Distributor
        },
        {
            path: '/AllProduct',
            name: 'AllProduct',
            redirect: '/AllProduct/Tetraproduct',
            component: AllProduct,
            children: [{
                path: '/AllProduct/Tetraproduct',
                name: 'Tetraproduct',
                component: Tetraproduct
            },
        ]
        },

        {
            // 详情页
            path: '/Tropicalfish',
            name: 'Tropicalfish',
            component: Tropicalfish
        },

        {
            path: '/contactUs',
            name: 'contactUs',
            component: contactUs
        },

    ]
})